<ejs-dialog #modal [isModal]='true' 
    [header]="'Históricos da Doença | ' + pacienteNome" 
    [visible]="false"
    class="custom-dialog"
    [ngClass]="{ 'em-operacao': emOperacao }"
    [showCloseIcon]='true' 
    (open)="abriuModal=true"
    (beforeClose)="fechandoModal($event)"
    [closeOnEscape]='true'>

    <ng-template #footerTemplate>
        <button ejs-button  class="e-btn " data-ripple="true" (click)='modal.hide()'>Ok</button>
    </ng-template>

    <ng-template #content>
        <div style="display: flex;flex-direction: column;height:100%;" *ngIf="abriuModal">
            <div class="filtro-container">
                <div class="filtro-campos">
                    <div class="filtro-campo">
                        <div class="filtro-label">
                            <i class="fal fa-heartbeat" style="color: #dc3545;"></i>Doença
                        </div>
                        <ejs-dropdownlist 
                            [dataSource]="doencas" 
                            [fields]="{text: 'cid10Texto', value: 'id'}"
                            [placeholder]="'Selecione uma doença específica do paciente'"
                            [enabled]="!todasDoencas"
                            [value]="doencaSelecionadaId"
                            (change)="onDoencaChange($event)"
                            [cssClass]="'custom-dropdown'">
                            <ng-template #itemTemplate let-data>
                                <div style="padding: 4px 0;">
                                    <span style="font-weight: 600; color: #6c757d; margin-right: 8px;">#{{data.id}}</span>
                                    <span style="color: #212529;">{{data.cid10Texto}}</span>
                                </div>
                            </ng-template>
                            <ng-template #valueTemplate let-data>
                                <div style="display: flex; align-items: center;">
                                    <span style="background: #6c757d; 
                                                 color: white; 
                                                 padding: 2px 8px; 
                                                 border-radius: 12px; 
                                                 font-size: 11px;
                                                 font-weight: 600;
                                                 margin: 6px;">
                                        #{{data.id}}
                                    </span>
                                    <span style="color: #212529;">{{data.cid10Texto}}</span>
                                </div>
                            </ng-template>
                        </ejs-dropdownlist>
                    </div>
                    <div class="filtro-campo-auto">
                        <ejs-checkbox 
                            label="Todas as doenças do paciente" 
                            [(checked)]="todasDoencas"
                            (change)="onTodasDoencasChange($event)"
                            [cssClass]="'custom-checkbox'">
                        </ejs-checkbox>
                    </div>
                </div>
            </div>
            <div style="flex-grow: 1;" *ngIf="abriuModal">
                <ejs-grid #grid  height="100%" [dataSource]="registros"
                    [enableVirtualization]='false' [filterSettings]='filterSettings'
                    [searchSettings]='searchSettings' [allowFiltering]='true' [allowSorting]='true'
                    [allowResizing]='true' [showColumnChooser]='true'
                    [allowTextWrap]='true'
                    class="grid-clickable"
                    [selectionSettings]="{ enableToggle: false }"
                    [toolbar]="toolbarItens"
                    (toolbarClick)='toobarClick($event);toolbar.handleExport($event, grid);'
                    [showColumnMenu]='true' [pageSettings]='{ pageSize: 100 }' [allowExcelExport]='true'
                    [allowPdfExport]='true' [allowPdfExport]='true' >
                    <e-columns>
                        <e-column field='id' width='30' [headerText]="'Id'" [isPrimaryKey]="true"
                            [visible]="true"></e-column>
                        <e-column field='dataAtendimento' width="72" [headerText]="'Data Atendimento'" [type]="'date'" 
                            [format]="{type: 'date', format: 'dd/MM/yyyy'}"></e-column>
                        <e-column field='acaoTexto' width='48' [headerText]="'Ação'" [visible]="true"></e-column>
                        <e-column field='cid10Texto'  width="150"  [headerText]="'CID10'" [visible]="true"></e-column>
                        <e-column field='descricao' [disableHtmlEncode]='false' [headerText]="'Descrição'">
                        </e-column>
                        <e-column field='profissional' width="135" [headerText]="'Médico'"></e-column>
                    </e-columns>

                    <e-aggregates>
                        <e-aggregate>
                            <e-columns>
                                <e-column field="dataAtendimento" type="count">
                                    <ng-template #footerTemplate let-data><b>Total: {{data.count}}</b></ng-template>
                                </e-column>
                            </e-columns>
                        </e-aggregate>
                    </e-aggregates>

                </ejs-grid>
            </div>
        </div>

    </ng-template>

</ejs-dialog>